module.exports = __webpack_public_path__ + "img/juxing.c0203bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/juxing.png
// module id = QbQI
// module chunks = 1